var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"burger",class:{ 'is-active': _vm.opened },on:{"click":function($event){return _vm.$emit('update', !_vm.opened)}}},[_c('span',{staticClass:"bar"}),_vm._v(" "),_c('span',{staticClass:"bar"})])}
var staticRenderFns = []

export { render, staticRenderFns }